import React, { useContext, useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { useNavigate, useParams } from "react-router-dom";

import { DataTable } from "primereact/datatable";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { Column } from "primereact/column";
import {
  PayCycleListColumns,
  PayCycleListColumnsForAdmin,
  PayCycleListColumnsForUser,
} from "../../appconfig/DatatableSetting";
import {
  getTwoFilteredDetails,
  postAllData,
} from "../../service/ProductService";
import {
  ADD_CLIENT_CHARGE,
  PAY_CYCLE_BY_CLIENT_ID,
} from "../../config/ApiConstant";
import {
  dateTemplate,
  payCycleTemplate,
} from "../../appconfig/TemplateFieldSetting";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { Badge } from "primereact/badge";
import { Card } from "primereact/card";
import { validateChargeStatus } from "../../config/Validate";
import { RadioButton } from "primereact/radiobutton";
import { Dialog } from "primereact/dialog";
import { formatDate, formatMonthYearUtc } from "../../appconfig/AppHelper";
import { Toast } from "primereact/toast";
import Loader from "../../components/Loader/Loader";

const PayCycle = () => {
  document.title = "Pay Cycle | Nexawage Payroll";

  const toast = useRef<any>(null);
  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const navigate = useNavigate();
  const { id } = useParams();
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [payCycle, setPayCycle] = useState<any>([]);
  const [clientData, setClientData] = useState<any>([]);
  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const userRole = userData?.roles?.role_name || "";
  const [globleClientData, setGlobalClientData] = useState<any>({});
  const [errors, setErrors] = useState<any>({});
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // add charge
  const [chargeDialog, setChargeDialog] = useState(false);

  const client_id = id
    ? (() => {
        try {
          return atob(id);
        } catch {
          return null;
        }
      })()
    : null;

  const columns =
    userRole === "Admin"
      ? PayCycleListColumnsForAdmin
      : userRole === "User"
      ? PayCycleListColumnsForUser
      : PayCycleListColumns;

  useEffect(() => {
    fetchPayCycle();

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [userData?.id]);

  useEffect(() => {
    fetchPayCycle();
  }, [selectedYear]);

  // left toolbar template
  // const leftToolbarTemplate = () => <></>;

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <div className="payrollreport-template">
        <>
          <Calendar
            value={moment(String(selectedYear), "YYYY").toDate()}
            view="year"
            dateFormat="yy"
            onChange={(e: any) => {
              const year = moment(e.value).year();
              if (year) setSelectedYear(year);
            }}
            showIcon
            placeholder="Select Year"
            className="ml-2 w-11rem"
          />
        </>
      </div>
    </>
  );

  // fetch pay cycle api call
  const fetchPayCycle = async () => {
    try {
      setPageLoad(false);
      let clientId;
      if (userRole === "Client") {
        clientId = userData?.id;
      } else if (userRole === "User" || userRole === "Admin") {
        clientId = client_id;
      }

      if (!clientId) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Client id is missing",
        });
        return;
      }

      const response = await getTwoFilteredDetails(
        PAY_CYCLE_BY_CLIENT_ID,
        "id",
        clientId,
        "year",
        selectedYear
      );

      const data = response;

      setPayCycle(data?.payCycleList);
      setClientData(data?.clientData);
      setPageLoad(true);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(true);
    }
  };

  //   action body template
  const actionBodyTemplate = (rowData: any) => {
    let clientId: any;
    if (userRole === "Client") {
      clientId = userData?.id;
    } else if (userRole === "User") {
      clientId = client_id;
    }
    return (
      <div className="name">
        <Button
          tooltip="Add"
          className="ml-2 common-primary-button"
          icon="pi pi-plus"
          label=""
          onClick={() =>
            navigate(
              `/pay-cycle/working-hours/${btoa(rowData.id)}/${btoa(clientId)}`
            )
          }
          disabled={rowData?.editable_status === true}
        />
      </div>
    );
  };

  // working hour template
  const workingHourTemplate = (rowData: any) => {
    if (rowData.working_hour_status === "NOT_EXIST") {
      return <Badge value={"NOT ADDED"} severity="danger" />;
    } else {
      return <Badge value={"ADDED"} severity="success" />;
    }
  };

  // add client charge template
  const addClientChargeTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-plus"
        tooltip="Payment Status"
        className="common-primary-button"
        // tooltipOptions={{ position: "bottom" }}
        disabled={rowData?.client_charge_status}
        onClick={() => openClientChargeDialog(rowData)}
      />
    </div>
  );

  // open client charge modal
  const openClientChargeDialog = (rowData: any) => {
    setGlobalClientData((prev: any) => ({
      ...prev,
      starting_date: rowData.starting_date,
      ending_date: rowData.ending_date,
      id: rowData.id,
      charge_paid: "",
    }));
    setChargeDialog(true);
  };

  // close client charge modal
  const closeClientChargeDialog = () => {
    setGlobalClientData({});
    setChargeDialog(false);
  };

  // input change function
  const onInputChange = (e: any, name: string) => {
    let val;
    val = e?.target?.value ?? e?.value;

    setGlobalClientData({ ...globleClientData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  //add cliend charge status api call
  const submitChargeStatus = async () => {
    const chargePaid = (globleClientData.charge_paid = 1);
    const { isError, errors } = validateChargeStatus(chargePaid);
    setErrors(errors);
    if (isError) return;

    const payload = {
      client_id: client_id,
      id: globleClientData.id,
      client_charge_status: chargePaid,
    };

    setSubmitLoading(true);
    try {
      const response = await postAllData(ADD_CLIENT_CHARGE, payload);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        setChargeDialog(false);
        setGlobalClientData({});
        fetchPayCycle();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu="Pay Cycle"
        pageName={userRole === "User" ? "Client Detail" : "List"}
        pageTitle={userRole === "User" ? "Client Detail" : "Pay Cycle List"}
        goToPage={userRole === "User" || userRole === "Admin"}
      />
      <Toast ref={toast} />
      <Card
        className="bg-white lg:p-2 crud-demo relative"
        style={{ marginBottom: "2rem" }}
      >
        {clientData && (userRole === "User" || userRole === "Admin") ? (
          <div className="grid ">
            <div className="col-12 md:col-12">
              <div className="grid p-fluid">
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Company Name:</label>
                  <div>{clientData?.company_name || "-"}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Email:</label>
                  <div>{clientData?.email || "-"}</div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Phone:</label>
                  <div>{clientData?.phone || "-"}</div>
                </div>

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Pay Scheme:</label>
                  <div>{clientData?.pay_schema || "-"}</div>
                </div>
                {/* <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Business No:</label>
                  <div>
                    {clientData?.bussiness_number?.slice(0, 9) +
                      " RP " +
                      clientData?.bussiness_number?.slice(-4) || "-"}
                  </div>
                </div> */}

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Pay Cheque Day:</label>

                  <div>
                    {" "}
                    {clientData?.pay_schema === "Bi Weekly"
                      ? "Upcoming Friday"
                      : clientData?.paycheck}
                  </div>
                </div>
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Client Payment:</label>
                  <div>{`$${clientData?.client_charge}` || "-"}</div>
                </div>
                {userRole === "Admin" && (
                  <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                    <label style={{ fontWeight: "bold" }}>
                      Client Payment Start Date:
                    </label>
                    <div>
                      {clientData?.client_subs_month_year
                        ? `${formatMonthYearUtc(
                            clientData?.client_subs_month_year
                          )}`
                        : "-"}
                    </div>
                  </div>
                )}

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>
                    Client Payroll Start Date:
                  </label>
                  <div>
                    {clientData?.client_payroll_starts_from
                      ? `${formatMonthYearUtc(
                          clientData?.client_payroll_starts_from
                        )}`
                      : "-"}
                  </div>
                </div>

                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Business No:</label>
                  <div>
                    {clientData?.bussiness_number?.slice(0, 9) +
                      " RP " +
                      clientData?.bussiness_number?.slice(-4) || "-"}
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        ) : (
          ""
        )}
        {(userRole === "User" || userRole === "Admin") && <hr />}

        <>
          {(userRole === "User" || userRole === "Admin") && (
            <h5 className="mb-3">Pay Cycles</h5>
          )}
          <Toolbar
            // left={leftToolbarTemplate}
            right={rightToolbarTemplate}
          />

          {pageLoad ? (
            <DataTable
              value={payCycle}
              showGridlines
              responsiveLayout="scroll"
              dataKey="id"
              stripedRows
              globalFilter={globalFilter}
              rows={defaultRowOptions}
              paginator={payCycle?.length > 0}
              rowsPerPageOptions={defaultPageRowOptions}
              className="datatable-responsive p-datatble-sm"
              paginatorTemplate={paginatorLinks}
              currentPageReportTemplate={showingEntries + " PayCycle"}
              emptyMessage="No Pay Cycle Data Found"
              filters={globalFieldFilter}
              onFilter={(e) => setGlobalFieldFilter(e.filters)}
              removableSort
            >
              {columns.map((col) => {
                if (col.field === "pay_period") {
                  return (
                    <Column
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={payCycleTemplate}
                    />
                  );
                } else if (col.field === "action") {
                  return (
                    <Column
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={actionBodyTemplate}
                    />
                  );
                } else if (col.field === "working_hour_status") {
                  return (
                    <Column
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={workingHourTemplate}
                    />
                  );
                } else if (col.field === "client_charge_status") {
                  return (
                    <Column
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={addClientChargeTemplate}
                    />
                  );
                } else if (col.field === "paycheck_date") {
                  return (
                    <Column
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={dateTemplate}
                      sortable
                    />
                  );
                } else {
                  return (
                    <Column
                      key={col.field}
                      field={col.field}
                      header={col.header}
                    />
                  );
                }
              })}
            </DataTable>
          ) : (
            <DataTable value={Skeletonitems}>
              {columns.map((col) => (
                <Column
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  body={SkeletonbodyTemplate}
                />
              ))}
            </DataTable>
          )}
        </>
        {pageLoad === false &&
          (userRole === "User" ||
            userRole === "Admin" ||
            userRole === "Client") && <Loader />}
      </Card>

      {/* add charge modal */}
      <Dialog
        visible={chargeDialog}
        header={"Client Payment Status"}
        draggable={false}
        className="mx-3 lg:mx-0 charge-status-modal"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="mr-2 p-button-secondary"
              onClick={closeClientChargeDialog}
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={submitChargeStatus}
              loading={submitLoading}
            />
          </div>
        }
        onHide={closeClientChargeDialog}
      >
        <h5 className="mb-1">
          Is Payment Paid For Pay Period Cycle From{" "}
          {formatDate(globleClientData?.starting_date) ?? ""} to {""}
          {formatDate(globleClientData?.ending_date) ?? ""}
        </h5>
        <small className="p-invalid-txt">{errors["charge_paid"]}</small>
      </Dialog>
    </>
  );
};

export default PayCycle;
